import { FC, memo } from 'react';
import { useTheme } from 'styled-components';
import { SVGIconProps } from 'types';

const SvgCaretIcon: FC<SVGIconProps> = ({ color: propsColor, size = 32, ...props }) => {
  const { colors } = useTheme();
  const color = propsColor || colors.neutrals[1];
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m17.563 16-6.6-6.6 1.885-1.885L21.333 16l-8.485 8.485-1.885-1.885 6.6-6.6Z" fill={color} />
    </svg>
  );
};

const Memo = memo(SvgCaretIcon);
export default Memo;
